// Textos dos Cadastros da Farm (02/11/2026), coletados por glob em core/i18n/messages.ts.
//
// Duas famílias: `farm.cadastros.*`, dos componentes de célula, e `declarative.*`, dos
// textos em PT puro dos configs, que o `useDeclarativeText` traduz na hora de mostrar.
// Os textos declarativos que o Hub já traduz em shared/i18n/declarativeText.i18n.ts,
// como Situação e Telefone, não se repetem aqui.
const pt: Record<string, string> = {
  'farm.cadastros.aba.safras': 'Safras',
  'farm.cadastros.aba.culturas': 'Culturas',
  'farm.cadastros.tipo.cliente_boitel': 'Cliente do boitel',
  'farm.cadastros.tipo.arrendatario': 'Arrendatário',
  'farm.cadastros.safra.planejada': 'Planejada',
  'farm.cadastros.safra.em_andamento': 'Em andamento',
  'farm.cadastros.safra.encerrada': 'Encerrada',
  'farm.cadastros.categoria.gerente': 'Gerente',
  'farm.cadastros.categoria.cartorio': 'Cartório',
  'farm.cadastros.categoria.orgao_ambiental': 'Órgão ambiental',
  'farm.cadastros.categoria.contabilidade': 'Contabilidade',
  'farm.cadastros.categoria.consultoria': 'Consultoria',
  'farm.cadastros.categoria.outro': 'Outro',
  'farm.cadastros.ciclo.anual': 'Anual',
  'farm.cadastros.ciclo.perene': 'Perene',
  'farm.cadastros.cicloDias': '{{n}} dias',
  'farm.cadastros.cicloAnos': '{{n}} anos até o corte',
  'farm.cadastros.todosImoveis': 'Todos os imóveis',
  'farm.cadastros.novoTitulo.parceiro': 'Novo parceiro',
  'farm.cadastros.novoTitulo.safra': 'Nova safra',
  'farm.cadastros.novoTitulo.cultura': 'Nova cultura',
  'farm.cadastros.novoTitulo.contato': 'Novo contato',
  'farm.cadastros.inativo': 'Inativo',
  'farm.cadastros.email': 'Escrever para {{email}}',
  'farm.cadastros.semContrato': 'Sem contrato vigente',
  'farm.cadastros.vigenteAte': 'Vigente até {{data}}',
  'farm.cadastros.inicioEm': 'Início {{data}}',
  'farm.cadastros.fimEm': 'Fim {{data}}',
  'farm.cadastros.contratosTitulo': 'Contratos vigentes',
  'farm.cadastros.contratosApoio': 'Lidos de Documentos. Para mudar um contrato, envie a nova versão lá.',
}
const en: Record<string, string> = {
  'farm.cadastros.aba.safras': 'Seasons',
  'farm.cadastros.aba.culturas': 'Crops',
  'farm.cadastros.tipo.cliente_boitel': 'Feedlot customer',
  'farm.cadastros.tipo.arrendatario': 'Tenant',
  'farm.cadastros.safra.planejada': 'Planned',
  'farm.cadastros.safra.em_andamento': 'In progress',
  'farm.cadastros.safra.encerrada': 'Closed',
  'farm.cadastros.categoria.gerente': 'Manager',
  'farm.cadastros.categoria.cartorio': 'Registry office',
  'farm.cadastros.categoria.orgao_ambiental': 'Environmental agency',
  'farm.cadastros.categoria.contabilidade': 'Accounting',
  'farm.cadastros.categoria.consultoria': 'Consulting',
  'farm.cadastros.categoria.outro': 'Other',
  'farm.cadastros.ciclo.anual': 'Annual',
  'farm.cadastros.ciclo.perene': 'Perennial',
  'farm.cadastros.cicloDias': '{{n}} days',
  'farm.cadastros.cicloAnos': '{{n}} years to harvest',
  'farm.cadastros.todosImoveis': 'All properties',
  'farm.cadastros.novoTitulo.parceiro': 'New partner',
  'farm.cadastros.novoTitulo.safra': 'New season',
  'farm.cadastros.novoTitulo.cultura': 'New crop',
  'farm.cadastros.novoTitulo.contato': 'New contact',
  'farm.cadastros.inativo': 'Inactive',
  'farm.cadastros.email': 'Write to {{email}}',
  'farm.cadastros.semContrato': 'No active contract',
  'farm.cadastros.vigenteAte': 'Valid until {{data}}',
  'farm.cadastros.inicioEm': 'Start {{data}}',
  'farm.cadastros.fimEm': 'End {{data}}',
  'farm.cadastros.contratosTitulo': 'Active contracts',
  'farm.cadastros.contratosApoio': 'Read from Documents. To change a contract, upload the new version there.',
}
const es: Record<string, string> = {
  'farm.cadastros.aba.safras': 'Zafras',
  'farm.cadastros.aba.culturas': 'Cultivos',
  'farm.cadastros.tipo.cliente_boitel': 'Cliente del engorde',
  'farm.cadastros.tipo.arrendatario': 'Arrendatario',
  'farm.cadastros.safra.planejada': 'Planificada',
  'farm.cadastros.safra.em_andamento': 'En curso',
  'farm.cadastros.safra.encerrada': 'Cerrada',
  'farm.cadastros.categoria.gerente': 'Gerente',
  'farm.cadastros.categoria.cartorio': 'Registro',
  'farm.cadastros.categoria.orgao_ambiental': 'Órgano ambiental',
  'farm.cadastros.categoria.contabilidade': 'Contabilidad',
  'farm.cadastros.categoria.consultoria': 'Consultoría',
  'farm.cadastros.categoria.outro': 'Otro',
  'farm.cadastros.ciclo.anual': 'Anual',
  'farm.cadastros.ciclo.perene': 'Perenne',
  'farm.cadastros.cicloDias': '{{n}} días',
  'farm.cadastros.cicloAnos': '{{n}} años hasta la corta',
  'farm.cadastros.todosImoveis': 'Todos los inmuebles',
  'farm.cadastros.novoTitulo.parceiro': 'Nuevo socio',
  'farm.cadastros.novoTitulo.safra': 'Nueva zafra',
  'farm.cadastros.novoTitulo.cultura': 'Nuevo cultivo',
  'farm.cadastros.novoTitulo.contato': 'Nuevo contacto',
  'farm.cadastros.inativo': 'Inactivo',
  'farm.cadastros.email': 'Escribir a {{email}}',
  'farm.cadastros.semContrato': 'Sin contrato vigente',
  'farm.cadastros.vigenteAte': 'Vigente hasta {{data}}',
  'farm.cadastros.inicioEm': 'Inicio {{data}}',
  'farm.cadastros.fimEm': 'Fin {{data}}',
  'farm.cadastros.contratosTitulo': 'Contratos vigentes',
  'farm.cadastros.contratosApoio': 'Leídos de Documentos. Para cambiar un contrato, suba la nueva versión allí.',
}

const declarativo = (source: string, english: string, spanish: string) => {
  const key = `declarative.${source}`
  pt[key] = source
  en[key] = english
  es[key] = spanish
}

;[
  ['Parceiros', 'Partners', 'Socios'],
  ['parceiro', 'partner', 'socio'],
  ['Parceiro', 'Partner', 'Socio'],
  ['Parceiros no filtro', 'Partners in filter', 'Socios en el filtro'],
  ['Safras', 'Seasons', 'Zafras'],
  ['safra', 'season', 'zafra'],
  ['Safra', 'Season', 'Zafra'],
  ['Culturas', 'Crops', 'Cultivos'],
  ['cultura', 'crop', 'cultivo'],
  ['Cultura', 'Crop', 'Cultivo'],
  ['Contatos', 'Contacts', 'Contactos'],
  ['contato', 'contact', 'contacto'],
  ['Contatos no filtro', 'Contacts in filter', 'Contactos en el filtro'],
  ['Imóveis', 'Properties', 'Inmuebles'],
  ['Imóvel', 'Property', 'Inmueble'],
  ['Contratos', 'Contracts', 'Contratos'],
  ['Período', 'Period', 'Período'],
  ['Ciclo', 'Cycle', 'Ciclo'],
  ['Organização', 'Organization', 'Organización'],
  ['Telefone e e-mail', 'Phone and e-mail', 'Teléfono y correo'],
  ['Nome ou razão social', 'Name or company name', 'Nombre o razón social'],
  ['Pessoa', 'Entity', 'Persona'],
  ['CNPJ ou CPF', 'Company or personal tax ID', 'CNPJ o CPF'],
  ['Imóveis vinculados', 'Linked properties', 'Inmuebles vinculados'],
  ['Início', 'Start', 'Inicio'],
  ['Fim', 'End', 'Fin'],
  ['Culturas da safra', 'Season crops', 'Cultivos de la zafra'],
  ['Cor no mapa', 'Map color', 'Color en el mapa'],
  ['Ciclo em dias', 'Cycle in days', 'Ciclo en días'],
  ['Unidade da colheita', 'Harvest unit', 'Unidad de cosecha'],
  ['Cliente do boitel', 'Feedlot customer', 'Cliente del engorde'],
  ['Clientes do boitel', 'Feedlot customers', 'Clientes del engorde'],
  ['Arrendatário', 'Tenant', 'Arrendatario'],
  ['Arrendatários', 'Tenants', 'Arrendatarios'],
  ['Pessoa jurídica', 'Company', 'Persona jurídica'],
  ['Pessoa física', 'Individual', 'Persona física'],
  ['Planejada', 'Planned', 'Planificada'],
  ['Encerrada', 'Closed', 'Cerrada'],
  ['Anual', 'Annual', 'Anual'],
  ['Perene', 'Perennial', 'Perenne'],
  ['Estéreos', 'Steres', 'Estéreos'],
  ['Hectares', 'Hectares', 'Hectáreas'],
  ['Gerente', 'Manager', 'Gerente'],
  ['Cartório', 'Registry office', 'Registro'],
  ['Órgão ambiental', 'Environmental agency', 'Órgano ambiental'],
  ['Contabilidade', 'Accounting', 'Contabilidad'],
  ['Consultoria', 'Consulting', 'Consultoría'],
  ['Outro', 'Other', 'Otro'],
  ['Todos os imóveis', 'All properties', 'Todos los inmuebles'],
  ['Informe o CNPJ ou CPF', 'Enter the tax ID', 'Informe el CNPJ o CPF'],
  ['Informe o contato', 'Enter the contact', 'Informe el contacto'],
  ['Use a sigla da UF', 'Use the state code', 'Use la sigla del estado'],
  ['Escolha ao menos um imóvel', 'Choose at least one property', 'Elija al menos un inmueble'],
  ['Documento incompleto', 'Incomplete tax ID', 'Documento incompleto'],
  ['Use o formato 2026/27', 'Use the format 2026/27', 'Use el formato 2026/27'],
  ['Informe o início', 'Enter the start', 'Informe el inicio'],
  ['Informe o fim', 'Enter the end', 'Informe el fin'],
  ['O fim vem depois do início', 'The end comes after the start', 'El fin va después del inicio'],
  ['Escolha uma cor', 'Choose a color', 'Elija un color'],
  ['Use dias inteiros', 'Use whole days', 'Use días enteros'],
  ['Escolha a unidade', 'Choose the unit', 'Elija la unidad'],
  ['Informe a organização', 'Enter the organization', 'Informe la organización'],
  ['Informe o telefone', 'Enter the phone', 'Informe el teléfono'],
].forEach(([source, english, spanish]) => declarativo(source, english, spanish))

export default { pt, en, es }
